import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"align-self":"center","padding-left":"10px"} }

import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideHeaderComponent',
  emits: ["close"],
  setup(__props, { emit: __emit }) {


const _emits = __emit

function onClick() {
  _emits("close")
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexRow, { style: {"justify-content":"space-between","padding-bottom":"10px"} }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(SogIcon, {
        icon: "mdi-close",
        style: {"margin-right":"10px","cursor":"pointer"},
        onClick: onClick
      })
    ]),
    _: 3
  }))
}
}

})